import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Redact any value that appears with the property name "request". Picks out specific values and returns only those
 * in order to avoid logging too much. Also has perf benefits as we avoid recursively redacting the entire request
 * object.
 */
export var redactRequestProperty = {
  // Handle request being included in errors.
  test: function test(propertyName, value) {
    return propertyName === 'request' && _typeof(value) === 'object' && value !== null;
  },
  replacement: function replacement(value) {
    return {
      uri: value.uri,
      method: value.method,
      headers: {
        'X-Caller-Client-ID': value.headers && value.headers['X-Caller-Client-ID']
      }
    };
  }
};